<template>
				<div class="textbox-bounds" style="height:300px;" >
				<div class="textbox" style="height:300px;">
					<div class="modal-wndow-content-title">
						<h3>הוספת לקוח</h3></div>
					<div class="login-info" v-if="loginState == 1">
						<p>הפרטים נרשמו, אנא היכנס לדף מחדש</p>
					</div>
					<div class="login-info" v-if="loginState == 0">
						<div id="selectLine" class="login-input-line">

						<div class="header-login-input-select">
							<select option v-if="true" id="branchInput"
												v-model:value="branchInput"
												onfocus="this.style.background='black';this.style.color='#c7b7a5';this.size=6;this.oldHeight=this.style.height;this.style.height='90px';"
												onblur='this.style.background="black";this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight;'
												onchange='this.style.background="transparent!important";this.size=1;this.blur();'>
								<option>מרכז (תל אביב)</option>
								<option>צפון (חיפה)</option>
							</select>
						</div>	
						</div>
						<div class="login-input-line errorMessage" >
							{{validationMessage}}
						</div>

						<div class="login-input-line">
							<input class="login-input" autocomplete="off" v-on:keyup.enter="focusNext(1)" placeholder="שם פרטי ושם משפחה" v-bind:value="nameInput" @input="onNameInput($event.target.value)" />
						</div>
						<div id="selectLine" class="login-input-line">
							<div class="login-select">
								<select option v-on:keyup.enter="focusNext(2)" v-if="auditionType == 'Rhythm'" id="instrumentSelect"
													v-model:value="instrumentInput"
													onfocus="this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.size=1; this.blur();'>
									<option>כלי נגינה ראשי</option>
									<option>שירה</option>
									<option>גיטרה חשמלית</option>
									<option>גיטרה אקוסטית</option>
									<option>חליליות</option>
									<option>קלידים</option>
									<option>בס</option>
									<option>תופים</option>
									<option>סקסופון אלט</option>
									<option>סקסופון טנור</option>
									<option>סקסופון בריטון</option>
									<option>סקסופון סופרן</option>
									<option>קלרינט</option>
									<option>מפוחית</option>
									<option>חליל צד</option>
									<option>חצוצרה</option>
									<option>טרומבון</option>
									<option>כלי הקשה</option>
									<option>כלי פריטה אחרים</option>
									<option>כלי קשת</option>
									<option>אני רב כלי</option>
								</select>
								<select style='color:"#FF632B";' v-on:keyup.enter="focusNext(2)"  v-if="auditionType == 'Ensemble'" id="instrumentSelect"
													v-model:value="instrumentInput"
													onfocus="this.style.color='#c7b7a5'"
													onblur='this.style.color="#FF632B"'
													onchange='this.size=1; this.blur();'>
									<option>שירה</option>
								</select>
							</div>
						</div>
						<div class="login-input-line">
							<input class="login-input"
							v-on:keyup.enter="focusNext(4)"
							 id="emailInputID"
										autocomplete="off"
										placeholder="אימייל"
										v-bind:value="emailInput"
										 @input="onEmailInput($event.target.value)" />
							
						</div>
						<div class="login-input-line">
						<input v-on:keyup.enter="focusNext(5)" dir="ltr" class="login-input" id="phoneInputID"  autocomplete="off" placeholder="נייד" v-bind:value="phoneInput" @focus="onPhoneInput($event.target.value)"   @input="onPhoneInput($event.target.value)" />
						</div>
						<div class="login-next-button"
							style="margin-left:100px;">
													<input
						  type="checkbox"
						  v-model="sendEmail"
						  v-bind:true-value="true"
						  v-bind:false-value="false"
						>שלח מייל
						</div>
						
						<label class="login-next-button"
									v-on:click="registerUser()">אישור</label>

					</div>
				</div>
			</div>
			</div>
</template>

<script>
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
var APIbase = "https://yard-bands.herokuapp.com"


export default {
	components: {},
	created() {
		
	},
	data() {
		return {
			nameInput : "",
			branchInput: "מרכז (תל אביב)",
			instrumentInput : "כלי נגינה ראשי",
			emailInput : "",
			phoneInput : "",
			validationMessage : "",
			loginState: 0,
			refreshId:0,
			auditionType : "Rhythm",
			sendEmail: "true"
		}
	},
	watch: {
		instrumentInput: function (val) {
			this.$forceUpdate();
		},
		auditionType: function (val) {
			if (val == 'Ensemble') {
				this.instrumentInput = 'שירה'
			}
			this.$forceUpdate();
		},
		sendEmail: function (val) {
			console.log(val === true);
		}
	},
	methods: {
	guid() {
		return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
			this.s4() + '-' + this.s4() + this.s4() + this.s4();
	},
	s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	},
	focusNext(num) {
		if (num == 1) {
			document.getElementById("instrumentSelect").focus();
		}
		else if (num == 2) {
		 document.getElementById("emailInputID").focus();
		}
		else if (num == 4) {
		 document.getElementById("phoneInputID").focus();
		}
		else {
			this.registerUser();
		}
	},
		registerUser(){
			this.validateInput()
			if (this.validationMessage === "") {
				var site = 'center';
				if (this.branchInput == 'צפון (חיפה)')
				{
					site = 'north';
				}
				if (this.sendEmail) {
					axios.post(APIbase+'/v2/create_user_for_detailes',{
										'name':this.nameInput,
										'instrument':this.instrumentInput,
										'email':this.emailInput,
										'phone':this.phoneInput,
										'site': site,
										'audition_type':this.auditionType
									}).then(response => {
									this.loginState = 1
					})
				}
				else {
					axios.post(APIbase+'/v2/create_user',{
										'user_id':this.guid(),
										'name':this.nameInput,
										'instrument':this.instrumentInput,
										'email':this.emailInput,
										'phone':this.phoneInput,
										'site': site,
										'audition_type':this.auditionType
									}).then(response => {
									this.loginState = 1
					})
				}
			}
		},
		onEmailInput(val){
			this.emailInput = val
		},
		onNameInput(val){
			this.nameInput = val
		},
		onPhoneInput(val){

			let allowedChars = "0123456789";
			let result = Array.from(val).filter(f=> allowedChars.includes(f)).join('');
			if (result.length > 10) {
				this.phoneInput = result.substring(0,10);
			}
			else {
				this.phoneInput = result;
			}
			this.$forceUpdate();

		},
		instrumentSelected(val){

		},
		validateEmail() {
			var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

				var emailParts = this.emailInput.split('@');

				if (emailParts.length !== 2) {
					return 1;
				}

				var account = emailParts[0];
  				var address = emailParts[1];

 				if (account.length > 64 || address.length > 255) {
					return 2;
				}
			        var domainParts = address.split('.');
  
			        if (domainParts.some(function (part) {
                                         return part.length > 63;
                                 })) {
					return 3;
				}
				if (!tester.test(this.emailInput)) {
					return 4;	
				}
				return 0;

		},
		validateInput() {
			var re = /\S+@\S+\.\S+/;
			if (this.nameInput === "") {
				this.validationMessage = "נא להקליד שם ושם משפחה"
			}
			else if (this.instrumentInput === "כלי נגינה"
			|| this.instrumentInput === "כלי נגינה ראשי") {
				this.validationMessage = "נא לבחור כלי נגינה ראשי";
			}
			else if (this.emailInput === "") {
				this.validationMessage = ""
			}
			else if (this.validateEmail() != 0) {
				this.validationMessage = "כתובת האימייל שהוקלדה אינה חוקית"
			}
			else if (this.phoneInput !== "" && this.phoneInput.length < 10) {
				this.validationMessage = "מספר הנייד צריך להכיל 10 ספרות"
			}
			else {
				this.validationMessage = ""
			}
			this.$forceUpdate();
		}


	}

}
</script>



// WEBPACK FOOTER //
// AddCustomer.vue?75f46fe6